"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodTitle = void 0;
const paymentMethodTitle = (paymentMethod) => {
    if (paymentMethod.Type === 'NewCreditCard')
        return 'New credit card';
    const { mask, type } = (() => {
        switch (paymentMethod.Type) {
            case 'CreditCard':
            case 'CreditCardReferenceTransaction':
            case 'Credit Card':
            case 'Debit Card':
                return {
                    mask: paymentMethod.CreditCardMaskNumber,
                    type: paymentMethod.CreditCardType,
                };
            case 'ACH':
                return {
                    mask: paymentMethod.AchAccountNumberMask,
                    type: 'Bank account',
                };
            default:
                return {
                    mask: 'XXXX',
                    type: 'Payment method',
                };
        }
    })();
    return `${type} ending in ${mask.substr(mask.length - 4)}`;
};
exports.paymentMethodTitle = paymentMethodTitle;
